import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Get CSRF token from cookie
export function getCsrfToken(): string | null {
  const name = 'csrftoken'
  let cookieValue = null
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }
  return cookieValue
}

// Get current tenant subdomain
export function getTenantSubdomain(): string {
  const hostname = window.location.hostname
  const parts = hostname.split('.')
  // For localhost:8000, return empty; for tenant.domain.com return tenant
  if (hostname.includes('localhost')) {
    return ''
  }
  return parts[0]
}
